import React, { Component } from 'react';
import { POInput } from './NametagReceiving/componentChildren/POInput';
import { POSummary } from './NametagReceiving/componentChildren/POSummary';
import { ScanTote } from './NametagReceiving/componentChildren/ScanTote';
import { TotePlacement } from './NametagReceiving/componentChildren/TotePlacement';
import { Audio } from './Widgets/Audio';
import './NametagReceiving/css/nametagReceiving.css'
import './SOPSummary/css/SOPSummary.css'
import { DialogMessage } from './Widgets/DialogMessage';
import { Loader } from './Widgets/Loader';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import './css/Confirm.css';

export class NametagReceiving extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userInput: '',
            POInfo: {},
            itemFilters: {},
            nametagBinInfo: {},
            errorDetails: {},
            missingItems: [],
            wrongItems: [],
            wrongBacking: [],
            toteId: "",
            stage: 'poLookup',
            hideCompletes: false,
            clearToteOnCancel: false,
            allItemsReceived: false,
            orderHadErrors: false,
            showDialog: false,
            isErrorMessage: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            loading: false
        };
        this.resetState = this.resetState.bind(this);
        this.closeDialog = this.closeDialog.bind(this);
        this.startLoading = this.startLoading.bind(this);
        this.stopLoading = this.stopLoading.bind(this);
        this.displayError = this.displayError.bind(this);
        this.showConfirm = this.showConfirm.bind(this);
        this.lookupPO = this.lookupPO.bind(this);
        this.lookupPOCallback = this.lookupPOCallback.bind(this);
        this.continueReceiving = this.continueReceiving.bind(this);
        this.assignTote = this.assignTote.bind(this);
        this.clearTotes = this.clearTotes.bind(this);
        this.checkToteStatus = this.checkToteStatus.bind(this);
        this.assignToteCallback = this.assignToteCallback.bind(this);
        this.confirmToteIsEmpty = this.confirmToteIsEmpty.bind(this);
        this.updateRecievedQty = this.updateRecievedQty.bind(this);
        this.buildFilterObject = this.buildFilterObject.bind(this);
        this.resetFilters = this.resetFilters.bind(this);
        this.updateFilterObject = this.updateFilterObject.bind(this);
        this.showHideCompletes = this.showHideCompletes.bind(this);
        this.filterItems = this.filterItems.bind(this);
        this.submitPurchaseOrder = this.submitPurchaseOrder.bind(this);
        this.submitPurchaseOrderCallback = this.submitPurchaseOrderCallback.bind(this);
        this.focusOnInput = this.focusOnInput.bind(this);
        this.updateInputValue = this.updateInputValue.bind(this);
        this.cancelSession = this.cancelSession.bind(this);
        this.cancelSessionCallback = this.cancelSessionCallback.bind(this);
        this.generateMissingItemsMessage = this.generateMissingItemsMessage.bind(this);
        this.generateWrongItemsMessage = this.generateWrongItemsMessage.bind(this);
        this.generateWrongBackingMessage = this.generateWrongBackingMessage.bind(this);
        this.handleMissingItems = this.handleMissingItems.bind(this);
        this.handleWrongItems = this.handleWrongItems.bind(this);
        this.handleWrongBacking = this.handleWrongBacking.bind(this);
        this.playNeedMoreInfo = this.playNeedMoreInfo.bind(this);
        
    }

    resetState() {
        this.setState({
            userInput: '',
            POInfo: {},
            itemFilters: {},
            nametagBinInfo: {},
            toteId: "",
            stage: 'poLookup',
            allItemsReceived: false,
            hideCompletes: false,
            clearToteOnCancel: false,
            orderHadErrors: false,
            showDialog: false,
            isErrorMessage: false,
            dialogTitle: "",
            dialogContent: "",
            dialogFullScreen: false,
            loading: false
        });
        
    }

    closeDialog() {
        this.setState({
            showDialog: false,
            dialogFullScreen: false,
            isErrorMessage: false
        });
        this.focusOnInput();
    }

    startLoading() {
        this.setState({
            loading: true
        });
    }

    stopLoading() {
        this.setState({
            loading: false
        });
    }

    displayError(title, message) {
        this.setState({
            dialogContent: message,
            dialogTitle: title,
            showDialog: true,
            isErrorMessage: true,
            actionDialog: false
        });
    }

    showConfirm(title, message, buttonTextPositive, buttonTextNegative, positiveFunction, negativeFunction, hideSubmit = false) {
        var buttons = [{
            label: buttonTextNegative,
            onClick: negativeFunction
        }];
        if (!hideSubmit) {
            buttons.push({
                label: buttonTextPositive,
                onClick: positiveFunction
            });
        }

        const options = {
            title: title,
            message: message,
            buttons: buttons,
            childrenElement: () => <div />,
            closeOnEscape: false,
            closeOnClickOutside: false,
            willUnmount: () => { },
            afterClose: () => { },
            onClickOutside: () => { },
            onKeypressEscape: () => { },
            overlayClassName: "confirm-message"
        };

        confirmAlert(options);
    }

    lookupPO(e) {
        e.preventDefault();
        if (this.state.userInput) {
            this.setState({
                loading: true,
            });
            this.lookupPOCallback();
        } else {
            this.focusOnInput();
        }
    }

    async lookupPOCallback() {
        var PONum = this.state.userInput;
        await this.props.makeRESTCall(
            'wmsnametagreceiving?recordNum=' + PONum,
            'get',
            null,
            (POLookupInfo) => {
                console.log("ORDER INFO", POLookupInfo);
                if (POLookupInfo.success) {
                    var POInfo = POLookupInfo.POInfo;
                    var nametagBinInfo = POLookupInfo.nametagBinInfo;
                    var canBeReceived = false;
                    var invalidMessage = "";
                    if (!POInfo.poId) {
                        invalidMessage = "The entered PO Number is invalid";
                    }
                    else if (!POInfo.nametagOrder || !POInfo.SOPId) {
                        invalidMessage = "This PO is not a Nametag Order and cannot be received here";
                    }
                    else if (!POInfo.pendingReceipt) {
                        invalidMessage = "This PO has Already Been Received";
                    }
                    else if (!POInfo.validSOPState) {
                        invalidMessage = "The associated sales order has been modified or is being processed and cannot be received at this time."
                    }
                    else {
                        canBeReceived = true;
                    }
                    if (canBeReceived) {
                        this.setState({
                            POInfo: POInfo,
                            toteId: POLookupInfo.toteId,
                            clearToteOnCancel: !POLookupInfo.toteId,
                            nametagBinInfo: nametagBinInfo,
                            stage: 'scanTote',
                            loading: false,
                            userInput: ''
                        });
                        this.buildFilterObject(POInfo.items);
                    }
                    else {
                        this.setState({
                            dialogContent: invalidMessage,
                            dialogTitle: "Invalid PO",
                            showDialog: true,
                            isErrorMessage: false,
                            userInput: '',
                            loading: false
                        });
                    }
                }
                else {
                    this.setState({
                        dialogContent: POLookupInfo.message,
                        dialogTitle: "Unable to look up order",
                        showDialog: true,
                        isErrorMessage: false,
                        userInput: '',
                        loading: false
                    });
                }
            },
            (title, error) => {
                console.error('Error:', error);
                var errorMessage;
                if (error.message == "Failed to fetch") {
                    errorMessage = "There was an Network error. Check your internet connection and try again";
                } else {
                    errorMessage = error;
                }
                this.setState({
                    dialogContent: errorMessage,
                    dialogTitle: "Unknown Error",
                    showDialog: true,
                    isErrorMessage: true
                });
            },
            () => {
                this.setState({
                    loading: false,
                    userInput: ''
                });
                this.focusOnInput();
            }
        );
    }

    continueReceiving() {
        this.setState({
            stage: 'poReceiving'
        });
    }

    assignTote(e) {
        e.preventDefault();
        var toteID = this.state.userInput;
        if (toteID) {
            this.setState({
               loading: true,
            });
            setTimeout(this.checkToteStatus);
        }
    }

    async clearTotes(modifySOP, toteIds) {
        var result = {};
        //needToUpdateState
        var postBody = {
            toteIdsToClear: toteIds,
            modifySOP: modifySOP
        };

        await this.props.makeRESTCall(
            'byusopcheckncleartotes',
            'post',
            postBody,
            (clearEmptyTotesInfo) => {
                result = clearEmptyTotesInfo;
            },
            (title, error) => {
                this.displayError(title, error);
            },
            () => {
            }
        );
        return result;
    }

    async checkToteStatus() {
        var toteId = this.state.userInput;
        var response = {
            success: false,
        };
        await this.props.makeRESTCall(
            'byusopcheckncleartotes?toteIds=' + toteId,
            'get',
            null,
            (checkTotesStatusInfo) => {
                console.log(checkTotesStatusInfo)
                if (checkTotesStatusInfo.success) {
                    response.success = true;
                    var toteIsEmpty = checkTotesStatusInfo.emptyToteIds.length > 0;
                    var toteIsInvalid = checkTotesStatusInfo.invalidTotes.length > 0;
                    var verifyTote = checkTotesStatusInfo.totesToConfirm.length > 0;
                    var toteIsUsed = checkTotesStatusInfo.totesUnableToClear.length > 0;
                    if (toteIsEmpty) {
                        this.assignToteCallback();
                    }
                    else if (toteIsInvalid) {
                        this.setState({
                            dialogTitle: "Invalid Tote",
                            dialogContent: "Tote " + toteId + " is not valid",
                            showDialog: true,
                            loading: false,
                            isErrorMessage: true,
                            toteId: "",
                            userInput: ''
                        });
                        return;
                    }
                    else if (verifyTote) {
                        this.stopLoading();
                        setTimeout(() => { this.confirmToteIsEmpty(toteId) });
                    }
                    else if(toteIsUsed) {
                        this.setState({
                            dialogTitle: "Tote in Use",
                            dialogContent: "Tote " + toteId + " is not available to use",
                            showDialog: true,
                            loading: false,
                            isErrorMessage: false,
                            toteId: "",
                            userInput: ''
                        });
                        return;
                    }
                } else {
                    this.stopLoading();
                    this.displayError("There was an error validating your totes, Please contact I.T.", checkTotesStatusInfo.message);
                    this.focusOnInput();
                }
            },
            (title, error) => {
                this.displayError(title, error);
            },
            () => {

            }
        );
        return response;
    }

    confirmToteIsEmpty(toteId) {
        this.showConfirm(
            "Verify Tote Status",
            "Is Tote " + toteId + " empty?",
            "Yes",
            "No",
            () => {
                this.startLoading();
                setTimeout(() => { this.assignToteCallback(true) });
            },
            () => {
                this.setState({
                    toteId: "",
                    userInput: '',
                    loading: false
                });
                this.focusOnInput();
            }
        );
    }

    async assignToteCallback(clearTotes = false) {
        var toteId = this.state.userInput;
        if (clearTotes) {
            await this.clearTotes(false, [toteId]);
        }
        var POInfo = this.state.POInfo;
        var putBody = {
            SOPId: POInfo.SOPId,
            toteId: toteId
        };
        await this.props.makeRESTCall(
            'byuassignsop',
            'put',
            putBody,
            (assignSOPData) => {
                var dialogContent = "";
                var dialogTitle = "";
                var isErrorMessage = false;
                var nextStage = "scanTote";
                var showDialog = false;
                if (assignSOPData.success) {
                    nextStage = "poReceiving";
                }
                else {
                    isErrorMessage = true;
                    dialogContent = assignSOPData.errMessage;
                    dialogTitle = "Error Assigning SO"
                    showDialog = true;
                }
                this.setState({
                    dialogTitle: dialogTitle,
                    dialogContent: dialogContent,
                    showDialog: showDialog,
                    loading: false,
                    isErrorMessage: isErrorMessage,
                    toteId: !isErrorMessage ? toteId : "",
                    stage: nextStage,
                    userInput: ''
                });
            },
            (title, error) => {
                console.error('Error:', error);
                this.setState({
                    dialogTitle: title,
                    dialogContent: error,
                    showDialog: true,
                    loading: false,
                    isErrorMessage: true
                });
            },
            () => {
                this.stopLoading();
            }
        );
    }

    updateRecievedQty(itemInfo) {
        var receivedItems = this.state.receivedItems;
        var poInfo = this.state.POInfo;
        var items = poInfo.items;
        var SOUniqueLineID = itemInfo.SOUniqueLineID;
        var newQty = itemInfo.quantityPicked;
        var itemUpdated = false;
        for (var i in receivedItems) {
            if (receivedItems[i].lineUniqueId == SOUniqueLineID) {
                receivedItems[i].qty = newQty;
                receivedItems[i].hasWrongItem = false;
                receivedItems[i].missingItem = false;
                receivedItems[i].hasWrongBacking = false;
                itemUpdated = true;
                break;
            }
        }
        if (!itemUpdated) {
            for (var j in items) {
                if (items[j].SOUniqueLineID == SOUniqueLineID) {
                   itemInfo.hasWrongItem = false;
                   itemInfo.missingItem = false;
                   itemInfo.hasWrongBacking = false;
                   items[j] = itemInfo;
                   poInfo.items = items;
                   itemUpdated = true;
                   break;
                }
            }
        }
        if (itemUpdated) {
            var SOUniqueLineID = itemInfo.SOUniqueLineID;
            var missingItems = this.state.missingItems;
            var wrongItems = this.state.wrongItems;
            //remove from missing items if it is there
            if (missingItems.indexOf(SOUniqueLineID) != -1) {
                missingItems.splice(missingItems.indexOf(SOUniqueLineID), 1);
            }
            //remove from wrong items if it is there
            if (wrongItems.indexOf(SOUniqueLineID) != -1) {
                wrongItems.splice(wrongItems.indexOf(SOUniqueLineID), 1);
            }
            this.setState({
                missingItems: missingItems,
                wrongItems: wrongItems
            });
        }
        this.setState({
            receivedItems: receivedItems,
            POInfo: poInfo
        });
    }

    buildFilterObject(items) {
        var filterObject = {};
        var filters = [];
        for (var i in items) {
            var optionsJSON = items[i].options;
            if (optionsJSON) {
                try {
                    var options = JSON.parse(optionsJSON);
                    for (var key in options) {
                        if (filters.indexOf(key) == -1) {
                            filterObject[key] = {
                                name: options[key].name,
                                value: "",
                                key: key
                            };
                            filters.push(key);
                        }
                    }
                } catch (err) {
                    console.log("BAD JSON", err);
                }
            }
        }
        console.log("ITEM FILTERS", filterObject)
        this.setState({
            itemFilters: filterObject
        });
    }

    resetFilters() {
        var filters = this.state.itemFilters;
        for (var key in filters) {
            filters[key].value = "";
        }
        this.setState({
            itemFilters: filters
        });
    }

    updateFilterObject(e, fieldId) {
        var value = e.target.value;
        var itemFilters = this.state.itemFilters;
        var itemFilter = itemFilters[fieldId];
        if (itemFilter) {
            itemFilter.value = value;
        }
        itemFilters[fieldId] = itemFilter;
        this.setState({
            itemFilters: itemFilters
        });
    }

    showHideCompletes() {
        var hideCompletes = this.state.hideCompletes;
        this.setState({
            hideCompletes: !hideCompletes
        });
        this.resetFilters();
    }

    filterItems(items) {
        var filteredItems = [];
        var itemFilters = this.state.itemFilters;
        for (var i in items) {
            var item = items[i];
            var hideItem = false;
            if ((item.quantityPicked == item.quantity) || item.missingItem || item.hasWrongItem || item.hasWrongBacking) {
                hideItem = this.state.hideCompletes;
            }
            var optionsJSON = item.options;
            var options = JSON.parse(optionsJSON);
            var filterMatch = true;
            for (var key in itemFilters) {
                if (itemFilters[key]) {
                    console.log("key", key);
                    console.log("ITEM FILTERS KEY", itemFilters[key]);
                    var filterValue = itemFilters[key].value;
                    if (filterValue) {
                        filterValue = filterValue.toLowerCase();
                    }
                    console.log("OPTIONS", options);
                    console.log("KEY", key);
                    var itemValue = options[key] ? options[key].text : "";
                    itemValue = itemValue.toLowerCase();
                    if (!itemValue.includes(filterValue)) {
                        filterMatch = false;
                        break;
                    }
                }
            }
            if (filterMatch && !hideItem) {
                filteredItems.push(item);
            }
        }
        return filteredItems;
    }

    submitPurchaseOrder() {
        var POInfo = this.state.POInfo;
        var items = POInfo.items;
        var allItemsHandled = true;
        for (var i in items) {
            var itemInfo = items[i];
            if (itemInfo.quantityPicked != itemInfo.quantity) {
                if (!itemInfo.missingItem && !itemInfo.hasWrongItem && !itemInfo.hasWrongBacking) {
                    allItemsHandled = false;
                }
            }
        };
        if (!allItemsHandled) {
            this.showConfirm(
                "Submit Session",
                "You must handle Missing/Misprinted items before submitting the session",
                "OK",
                "OK",
                () => { },
                () => { },
                true
            );
        }
        else {
            this.startLoading();
            setTimeout(this.submitPurchaseOrderCallback);
        }
    }

    async submitPurchaseOrderCallback() {
        var POInfo = this.state.POInfo;
        var missingItems = this.state.missingItems;
        var wrongItems = this.state.wrongItems;
        console.log("MISSING ITEMS", missingItems);
        console.log("WRONG ITEMS", wrongItems);
        var items = POInfo.items;
        var receivedItems = [];
        var allItemsReceived = true;
        var itemErrorMessages = [];
        for (var i in items) {
            var itemInfo = items[i];
            if (itemInfo.missingItem) {
                itemErrorMessages.push(this.generateMissingItemsMessage(itemInfo));
            }
            if (itemInfo.hasWrongItem) {
                itemErrorMessages.push(this.generateWrongItemsMessage(itemInfo));
            }
            if (itemInfo.hasWrongBacking) {
                itemErrorMessages.push(this.generateWrongBackingMessage(itemInfo));
            }
            if (itemInfo.quantityPicked != itemInfo.quantity) {
                allItemsReceived = false;
            }
            if (itemInfo.quantityPicked > 0) {
                var inventoryDetail = JSON.parse(JSON.stringify(this.state.nametagBinInfo));
                inventoryDetail.qty = itemInfo.quantityPicked;
                receivedItems.push(
                    {
                        lineUniqueId: itemInfo.SOUniqueLineID,
                        qty: itemInfo.quantityPicked,
                        qtyCancelled: 0,
                        isBackordered: false,
                        isFulfillable: true,
                        doSubstitution: false,
                        location: "3",
                        usesBins: true,
                        inventoryDetail: [inventoryDetail],
                        itemId: itemInfo.itemId
                    }
                );
            }
        }
        var postBody = {
            POId: this.state.POInfo.poId,
            PONumber: this.state.POInfo.poNumber,
            SOPId: this.state.POInfo.SOPId,
            readyToBill: (this.state.POInfo.readyToBill && allItemsReceived),
            items: receivedItems,
            employeeId: this.props.userId,
            allItemsReceived: allItemsReceived,
            itemErrorMessages: itemErrorMessages
        };
        await this.props.makeRESTCall(
            'wmsnametagreceiving',
            'post',
            postBody,
            (receivePOInfo) => {
                if (receivePOInfo.success) {
                    this.setState({
                        allItemsReceived: allItemsReceived,
                        orderHadErrors: itemErrorMessages.length > 0,
                        stage: 'placeTote'
                    })
                }
                else {
                    this.setState({
                        dialogTitle: "Error Submitting Session",
                        dialogContent: receivePOInfo.message,
                        showDialog: true,
                        loading: false,
                        isErrorMessage: true
                    });
                }
            },
            (title, error) => {
                this.displayError(title, error);
            },
            () => {
                this.stopLoading();
            }
        );
    }

    focusOnInput() {
        var POInputBox = document.getElementById("scanPO");
        var toteInputBox = document.getElementById("scanTote");
        if (POInputBox) {
            POInputBox.focus();
        }
        else if (toteInputBox) {
            toteInputBox.focus();
        }
    }

    updateInputValue(inputValue) {
        this.setState({
            userInput: inputValue.toUpperCase()
        });
    }

    cancelSession() {
        this.showConfirm(
            "Cancel Session",
            "Are You Sure You Want to Cancel the Session? Any Work will be Lost.",
            "Continue Receiving",
            "Cancel Session",
            () => {  },
            () => {
                this.startLoading();
                setTimeout(this.cancelSessionCallback)
            }
        );
    }

    async cancelSessionCallback() {
        if (this.state.clearToteOnCancel) {
            var postBody = {
                SOPId: this.state.POInfo.SOPId,
                cancelSession: true,
                toteId: this.state.toteId
            };
            await this.props.makeRESTCall(
                'wmsnametagreceiving',
                'post',
                postBody,
                (cancelSessionInfo) => {

                    console.log("Cancel Session INFO", cancelSessionInfo);
                    if (cancelSessionInfo.success) {
                        this.resetState();
                    }
                    else {
                        this.displayError("Unable to Cancel", "There was an error canceling the session");
                    }
                },
                (title, error) => {
                    this.displayError(title, error);
                },
                () => {
                    this.stopLoading();
                }
            );
        }
        else {
            this.resetState();
        }
        
    }

    generateMissingItemsMessage(itemInfo) {
        var itemName = itemInfo.item;
        var quantityMissing = itemInfo.quantity - itemInfo.quantityPicked;
        var options = JSON.parse(itemInfo.options);
        var messageText = "We are missing " + quantityMissing + " of " + itemName;
        messageText += "\nItem Id: " + itemInfo.itemId + "\nQty: " + quantityMissing;
        for (var key in options) {
            var option = options[key];
            messageText += "\n" + option.name + ": " + option.text;
        }
        messageText += "\nRedo Reason: Did Not Receive"
        return messageText;
    }

    generateWrongItemsMessage(itemInfo) {
        var itemName = itemInfo.item;
        var quantityMissing = itemInfo.quantity - itemInfo.quantityPicked;
        var options = JSON.parse(itemInfo.options);
        var messageText = itemName + " was Printed Wrong";
        var moreInfo = this.state.errorDetails[itemInfo.SOUniqueLineID + "-wrong"];
        if (moreInfo) {
            messageText += "\n " + moreInfo;
        }
        messageText += "\nItem Id: " + itemInfo.itemId + "\nQty: " + quantityMissing;
        for (var key in options) {
            var option = options[key];
            messageText += "\n" + option.name + ": " + option.text;
        }
        messageText += "\nRedo Reason: Misprint"
        return messageText;
    }

    generateWrongBackingMessage(itemInfo) {
        var itemName = itemInfo.item;
        var quantityMissing = itemInfo.quantity - itemInfo.quantityPicked;
        var options = JSON.parse(itemInfo.options);
        var messageText = itemName + " had the Wrong Backing";
        var moreInfo = this.state.errorDetails[itemInfo.SOUniqueLineID + "-backing"];
        if (moreInfo) {
            messageText += "\n " + moreInfo;
        }
        messageText += "\nItem Id: " + itemInfo.itemId + "\nQty: " + quantityMissing;
        for (var key in options) {
            var option = options[key];
            messageText += "\n" + option.name + ": " + option.text;
        }
        messageText += "\nRedo Reason: Wrong Backing"
        return messageText;
    }

    handleMissingItems(itemInfo) {
        var receivedItems = this.state.receivedItems;
        var poInfo = this.state.POInfo;
        var items = poInfo.items;
        var missingItems = this.state.missingItems;
        console.log(itemInfo)
        if (missingItems.indexOf(itemInfo.SOUniqueLineID) == -1) {
            missingItems.push(itemInfo.SOUniqueLineID);
            for (var i in receivedItems) {
                if (receivedItems[i].lineUniqueId == itemInfo.SOUniqueLineID) {
                    receivedItems[i].missingItem = true;
                    break;
                }
            }
            for (var j in items) {
                if (items[j].SOUniqueLineID == itemInfo.SOUniqueLineID) {
                    items[j].missingItem = true;
                    poInfo.items = items;
                    break;
                }
            }
        }
        this.setState({
            missingItems: missingItems,
            receivedItems: receivedItems,
            POInfo: poInfo
        });
    }

    handleWrongItems(itemInfo) {
        var receivedItems = this.state.receivedItems;
        var poInfo = this.state.POInfo;
        var items = poInfo.items;
        var wrongItems = this.state.wrongItems;
        var errorDetails = this.state.errorDetails;
        console.log(itemInfo)
        if (wrongItems.indexOf(itemInfo.SOUniqueLineID) == -1) {
            wrongItems.push(itemInfo.SOUniqueLineID);
            var promptMessage = "What was wrong with the item?";
            this.playNeedMoreInfo();
            var moreInfo = window.prompt(promptMessage);
            if (moreInfo) {
                errorDetails[itemInfo.SOUniqueLineID + "-wrong"] = "\n" + promptMessage + ": " + moreInfo;
            }
            for (var i in receivedItems) {
                if (receivedItems[i].lineUniqueId == itemInfo.SOUniqueLineID) {
                    receivedItems[i].hasWrongItem = true;
                    break;
                }
            }
            for (var j in items) {
                if (items[j].SOUniqueLineID == itemInfo.SOUniqueLineID) {
                    items[j].hasWrongItem = true;
                    poInfo.items = items;
                    break;
                }
            }
        }
        this.setState({
            wrongItems: wrongItems,
            receivedItems: receivedItems,
            POInfo: poInfo,
            errorDetails: errorDetails
        });
    }

    handleWrongBacking(itemInfo) {
        var receivedItems = this.state.receivedItems;
        var poInfo = this.state.POInfo;
        var items = poInfo.items;
        var wrongBacking = this.state.wrongBacking;
        var errorDetails = this.state.errorDetails;
        console.log(itemInfo)
        if (wrongBacking.indexOf(itemInfo.SOUniqueLineID) == -1) {
            wrongBacking.push(itemInfo.SOUniqueLineID);
            const promptMessage = "What was wrong with the backing?";
            this.playNeedMoreInfo();
            var moreInfo = window.prompt(promptMessage);
            if (moreInfo) {
                errorDetails[itemInfo.SOUniqueLineID + "-wrong"] = "\n" + promptMessage + ": " + moreInfo;
            }
            for (var i in receivedItems) {
                if (receivedItems[i].lineUniqueId == itemInfo.SOUniqueLineID) {
                    receivedItems[i].hasWrongBacking = true;
                    break;
                }
            }
            for (var j in items) {
                if (items[j].SOUniqueLineID == itemInfo.SOUniqueLineID) {
                    items[j].hasWrongBacking = true;
                    poInfo.items = items;
                    break;
                }
            }
        }
        this.setState({
            wrongBacking: wrongBacking,
            receivedItems: receivedItems,
            POInfo: poInfo,
            errorDetails: errorDetails
        });
    }

    playNeedMoreInfo() {
        const audioElNeedInfo = document.getElementsByClassName("audio-element-mi")[0];
        if (audioElNeedInfo.paused) {
            audioElNeedInfo.play();
        } else {
            audioElNeedInfo.currentTime = 0
        }
    }

    render() {
        return (
            <div className="nametag-receiving">
                <Audio />
                <DialogMessage
                    closeDialog={this.closeDialog}
                    showDialog={this.state.showDialog}
                    dialogTitle={this.state.dialogTitle}
                    dialogContent={this.state.dialogContent}
                    isErrorMessage={this.state.isErrorMessage}
                    dialogFullScreen={this.state.dialogFullScreen}
                />
                {
                    this.state.loading && <Loader />
                }
                {
                    this.state.stage == "poLookup"
                    &&
                    <POInput
                        lookupPO={this.lookupPO}
                        updateInputValue={this.updateInputValue}
                        userInput={this.state.userInput}
                    />
                }
                {
                    this.state.stage == "scanTote"
                    &&
                    <ScanTote
                        toteId={this.state.toteId}
                        POInfo={this.state.POInfo}
                        resetState={this.resetState}
                        continueReceiving={this.continueReceiving}
                        assignTote={this.assignTote}
                        userInput={this.state.userInput}
                        updateInputValue={this.updateInputValue}
                    />
                }
                {
                    this.state.stage == "poReceiving"
                    &&
                    <POSummary
                        POInfo={this.state.POInfo}
                        cancelSession={this.cancelSession}
                        updateRecievedQty={this.updateRecievedQty}
                        submitPurchaseOrder={this.submitPurchaseOrder}
                        updateFilterObject={this.updateFilterObject}
                        resetFilters={this.resetFilters}
                        showHideCompletes={this.showHideCompletes}
                        hideCompletes={this.state.hideCompletes}
                        itemFilters={this.state.itemFilters}
                        filterItems={this.filterItems}
                        handleMissingItems={this.handleMissingItems}
                        handleWrongItems={this.handleWrongItems}
                        handleWrongBacking={this.handleWrongBacking}
                        toteId={this.state.toteId}
                    />
                }
                {
                    this.state.stage == "placeTote"
                    &&
                    <TotePlacement
                        tote={this.state.toteId}
                        resetState={this.resetState}
                        POInfo={this.state.POInfo}
                        allItemsReceived={this.state.allItemsReceived}
                        orderHadErrors={this.state.orderHadErrors}
                    />
                }
            </div>
        );
    }
}
